import React from 'react';
import { getFieldValue } from '@sitecore-jss/sitecore-jss-react';
import { useCountryValue } from 'stores/country';
import pageTypes from 'utils/pageTypes';
import useMetroSearchSelectedMetro from 'utils/hooks/useMetroSearchSelectedMetro';
import { SavingsCalculatorSidebar } from 'components/components/organisms';

const normalizeMarket = (value) =>
  value ? value.toString().trim().toLowerCase() : '';

const shouldShowMetroSearchSidebar = (markets, selectedMetro) => {
  if (!Array.isArray(markets) || !markets.length) return false;

  const selectedMetros = Array.isArray(selectedMetro)
    ? selectedMetro
    : selectedMetro
    ? [selectedMetro]
    : [];

  if (!selectedMetros.length) return false;

  return markets.some((market) => {
    if (!market) return false;

    return selectedMetros.some(
      (metro) =>
        normalizeMarket(metro && metro.name) ===
          normalizeMarket(market.displayName) && market.showSidabar,
    );
  });
};

const SavingsCalculatorSidebarContainer = ({ fields }) => {
  const sidebar = getFieldValue(fields, 'sidebar') || {};
  const [{ country }] = useCountryValue();
  const selectedCountry = country === 'USA' ? 'United States' : 'Canada';

  const provinces =
    sidebar &&
    sidebar.provinces &&
    sidebar.provinces.filter((c) => c.country === selectedCountry);
  const selectedSidebar =
    country === 'USA'
      ? sidebar && sidebar.usSidebar
      : sidebar && sidebar.caSidebar;

  const currentPageType = getFieldValue(fields, 'currentPageType');
  const { metroSearchSelectedMetro } = useMetroSearchSelectedMetro();
  const markets = sidebar && sidebar.markets;

  if (!selectedSidebar) return '';
  const isVisible =
    currentPageType !== pageTypes.MetroSearch
      ? selectedSidebar.activate
      : shouldShowMetroSearchSidebar(markets, metroSearchSelectedMetro);

  return (
    <>
      <SavingsCalculatorSidebar
        title={selectedSidebar.sidebarTitle}
        isVisible={isVisible}
        ctaText={selectedSidebar.sidebarCTAText}
        sidebarCTALink={selectedSidebar.sidebarCTALink}
        modalCalculator={{
          title: selectedSidebar.modalTitle,
          text: selectedSidebar.modalText,
          disclaimer: selectedSidebar.modalDisclaimer,
          calculatedPriceText: selectedSidebar.calculatedPriceText,
          taxRateList: provinces,
        }}
      />
    </>
  );
};

export default SavingsCalculatorSidebarContainer;
